import { useIsFetching } from "@tanstack/react-query";

export function GlobalLoadingBar() {
  const isFetching = useIsFetching();

  if (isFetching === 0) return null;

  return (
    <div className="fixed top-14 lg:top-0 left-0 lg:left-[280px] right-0 z-50 h-0.5 overflow-hidden bg-black/5">
      <div className="h-full w-1/3 bg-[var(--accent-raw)] animate-loading-bar" />
    </div>
  );
}
